import type { ClientQuestion, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export interface SingleChoiceProps {
  question: Extract<ClientQuestion, { kind: 'single' }>;
  value: string | undefined;
  onChange: (value: string) => void;
  locale: LocaleCode;
}

/** kind: 'single' — emits the chosen choice id string. */
export function SingleChoice({ question, value, onChange, locale }: SingleChoiceProps) {
  return (
    <fieldset data-quiz-kind="single">
      <legend>{resolveLocalized(question.prompt, locale)}</legend>
      {(question.choices ?? []).map((choice) => {
        const label = resolveLocalized(choice.label, locale);
        return (
          <label key={choice.id}>
            <input
              type="radio"
              name={question.id}
              value={choice.id}
              checked={value === choice.id}
              onChange={() => onChange(choice.id)}
            />
            {label}
          </label>
        );
      })}
    </fieldset>
  );
}
